import AudienceSize from './components/AudienceSize.vue'

export default AudienceSize



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/lasGraphs/audienceSize/index.js